<template>
    <v-dialog v-model="isOpen" max-width="550">
        <template v-slot:activator="{ on }">
            <slot name="activator" v-bind="{ on }" />
        </template>

        <v-card>
            <v-card-title class="primary py-1 subtitle white--text">
                Mot de passe oublié
            </v-card-title>

            <v-card-text>
                <p class="pt-4">
                    Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.
                </p>

                <v-text-field v-model="email" label="Email" prepend-icon="fas fa-envelope" type="text" outlined dense hide-details />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn @click="submit" color="primary" small> Envoyer </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        email: '',
        isOpen: false
    }),

    methods: {
        open(email) {
            this.email = email;
            this.isOpen = true;
        },

        async submit() {
            try {
                this.setLoading(true);

                const body = {
                    email: this.email,
                    providerCode: this.$store.state.application.providerCode
                };
                const { success, err } = await this.repos.auth.forgotPassword(body);
                if (success) {
                    this.$notify({
                        title: 'Information',
                        text: 'Un email contenant un lien de réinitialisation vous a été envoyé.',
                        type: 'success'
                    });
                    this.isOpen = false;
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: err,
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        }
    }
};
</script>